import React, { useEffect, useState } from "react";
import { Table } from "antd";
import "./Table.scss";

export const columnsCsv = [
  {
    title: "Customer Name",
    dataIndex: "CustomerName",
    key: "CustomerName",
  },
  {
    title: "Service Type",
    dataIndex: "ServiceType",
    key: "ServiceType",
  },
  {
    title: "Customer Phone Number",
    dataIndex: "PhoneNumber",
    key: "PhoneNumber",
  },
];

export const columnsHubspot = [
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "First Name",
    dataIndex: "firstname",
    key: "firstname",
  },
  {
    title: "Last Name",
    dataIndex: "lastname",
    key: "lastname",
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Lead",
    dataIndex: "hs_lead_status",
    key: "hs_lead_status",
  },
];

export const TableCSV = ({ data, columns }) => {
  return (
    <div className="mt-4">
      <Table columns={columns} dataSource={data} />
    </div>
  );
};

export const TableHubspot = ({ data, columns }) => {
  const [sourceData, setSourceData] = useState([]);

  const filteredData = (data) => {
    let ans;
    if (data && data.length != 0) {
      ans = data.map((item) => item?.properties);
    }
    setSourceData(ans);
  };

  useEffect(() => {
    filteredData(data);
  }, []);

  console.log("Table Hubspot Stats", data);
  console.log("Table Hubspot sourceData", sourceData);

  return (
    <div className="mt-4">
      <Table columns={columns} dataSource={sourceData} />
    </div>
  );
};
